<template>
	<FormTitle
		v-if="title"
		:text="title"
		:required="required"
		:title-active="titleActive"
		:error="errorText ? true : false"
		:disabled="disabled"
		:kizuna-type="kizunaType"
	/>

	<div class="form_group" :class="[formClass, { error: errorClass }]">
		<multiselect
			placeholder=""
			v-model="multiValue"
			:options="options"
			:multiple="true"
			:disabled="disabled"
			:close-on-select="false"
			:deselectLabel="''"
			:selectLabel="''"
			:selectedLabel="''"
		></multiselect>
	</div>

	<ErrorText :text="errorText" />
</template>

<script setup>
import ErrorText from "@/components/atoms/ErrorText.vue";
import FormTitle from "@/components/atoms/FormTitle.vue";
import { computed, onMounted, ref } from "vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	enum: [String, Object],
	title: String,
	formClass: [String, Array],
	disabled: Boolean,
	required: Boolean,
	placeholder: String,
	selectType: String,
	errorText: String,
	kizunaType: Number
});
const model = defineModel();
/* ---------------------------------------------------------------------------
data
---------------------------------------------------------------------------- */
const titleActive = ref(false);
const errorClass = ref("");

// countryオブジェクトの値を配列に変換してoptionsとして使用
const options = computed(() => Object.values(props.enum));

const multiValue = computed({
	get() {
		// IDがcountryに存在する場合のみ取得
		return model.value.map(id => props.enum[id]).filter(name => name);
	},
	set(newValues) {
		// newValuesは国名の配列を想定
		// 国名からIDを取得してmodelを更新する
		const newIds = Object.keys(props.enum)
			.filter(key => newValues.includes(props.enum[key]))
			.map(Number);
		// 新しいIDの配列をセット
		model.value = newIds;
	}
});

/* ---------------------------------------------------------------------------
	バリデーション
---------------------------------------------------------------------------- */

onMounted(() => {});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.select {
	height: 40px;
	font-size: 1.4rem;
	position: relative;
	font-weight: normal;
	@include trans(0.3);
	padding: 10px 22px 6px 6px;
	border-radius: 5px;
	background-color: $bg-white2;
	border: 1px solid $bg-gray2;
	&:focus {
		@include trans(0.3);
		border-color: $primaryColor;
		background-color: rgba(10, 186, 181, 0.2);
	}
	&.error {
		background-color: rgba(250, 183, 195, 0.3);
	}
	&.required {
		background-color: rgba(250, 183, 195, 0.3);
	}
	&.placeholder {
		color: #d9d9d9;
	}
}
select:disabled {
	color: $color-gray4;
	opacity: 1 !important;
	background: #eee;
}
.form_group {
	display: flex;
	align-items: flex-end;
}
.form_group.error .select {
	color: $baseTextColor;
	border-color: $bg-red2;
	background-color: rgba(250, 183, 195, 0.2);
}
</style>
